import React, { useEffect } from 'react';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import {
    QueryClient,
    QueryClientProvider,
} from 'react-query';

import { withQuery, useQueryClient } from './contexts/queryClient';
import { withUser, UserProvider } from './contexts/user';
import Router from './screens/Router';

const queryClient = new QueryClient();

window.isNew = false;

console.log({ deploy_test: true });

try {
    if (window.location.search.includes('new-admin=1')) {
        localStorage.setItem('new-admin', '1');
    } else if (window.location.search.includes('new-admin=0')) {
        localStorage.setItem('new-admin', '0');
    }

    window.isNew = localStorage.getItem('new-admin') === '1';
} catch (error) {
    window.isNew = false;
}

require('./css/bootstrap.min.css');
require('./css/bootstrap-grid.min.css');
require('./css/bootstrap-reboot.min.css');
require('./css/index.css');

library.add(fab);
library.add(fas);

function App() {
    const { setQueryClient } = useQueryClient();

    useEffect(() => {
        setQueryClient(queryClient);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <MantineProvider
                withGlobalStyles
                withNormalizeCSS
                withCSSVariables={window.isNew}
                theme={window.isNew ? { headings: { fontFamily: 'Helvetica Neue, sans-serif' } } : null}
            >
                <DatesProvider settings={{ locale: 'ru' }}>
                    <Notifications position="top-right" />
                    <UserProvider>
                        <ModalsProvider>
                            <Router />
                        </ModalsProvider>
                    </UserProvider>
                </DatesProvider>
            </MantineProvider>
        </QueryClientProvider>
    );
}

export default withQuery(withUser(App));
